import axios from "axios";

// ─────────────────────────────────────────────────────────────────────────────
// Personal Tasks ("My Tasks", Reports menu) — dedicated API client.
// Own base path (/api/personal-tasks), own service file. Super-admin only.
// ─────────────────────────────────────────────────────────────────────────────
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";
const BASE = `${API_BASE_URL}/api/personal-tasks`;

// params: { view: "today" | "overdue" | "completed" | "pending" | "all", status, priority }
export const ptListTasks = (params = {}) => axios.get(BASE, { params });

export const ptGetTask = (id) => axios.get(`${BASE}/${id}`);

export const ptCreateTask = (payload) => axios.post(BASE, payload);

export const ptUpdateTask = (id, payload) => axios.patch(`${BASE}/${id}`, payload);

// payload: { status: "Pending" | "In Progress" | "Complete", remarks? }
export const ptUpdateTaskStatus = (id, payload) =>
  axios.patch(`${BASE}/${id}/status`, payload);

export const ptToggleTask = (id) => axios.patch(`${BASE}/${id}/toggle`);

export const ptDeleteTask = (id) => axios.delete(`${BASE}/${id}`);
